module.exports = __webpack_public_path__ + "img/Equipe.0c11f905.gif";